import { Button, InputWraper, useForm } from 'modules';
import React from 'react';
import { useGetListBanksQuery } from 'services';
import toast from 'react-hot-toast';
import * as Yup from 'yup';
import { InputText, InputSelect } from 'components';
import { PopupWraper } from '../../../../components/popup';
import { useCreateAccountBankMutation } from 'services';
import { useGetUserProfileQuery } from 'services';
import { components } from 'react-select';

const componentsElement = components as any;

interface CreateAccountBankProps {
  onClose: () => void;
  forceUpdateTable: () => void;
}

const CustomOption = (props: any) => (
  <componentsElement.Option {...props}>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img src={props.data.logo} alt='' className='image-bank' />
      {props.data.label}
    </div>
  </componentsElement.Option>
);

const CustomSingleValue = (props: any) => (
  <componentsElement.SingleValue {...props}>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        minWidth: 500,
      }}
    >
      <img src={props.data.logo} alt='' className='image-bank' />
      {props.data.label}
    </div>
  </componentsElement.SingleValue>
);

const CustomControl = (props: any) => (
  <componentsElement.Control {...props}>
    <div
      style={{
        padding: 5,
        backgroundColor: 'transparent',
        width: '100%',
        height: '100%',
        display: 'flex',
      }}
    >
      {props.children}
    </div>
  </componentsElement.Control>
);

const CustomMenu = (props: any) => (
  <componentsElement.Menu {...props}>
    <div
      style={{
        backgroundColor: 'transparent',
        borderRadius: 4,
        width: '100%',
        height: '100%',
        display: 'flex',
      }}
    >
      {props.children}
    </div>
  </componentsElement.Menu>
);

const CreateUser = ({ onClose, forceUpdateTable }: CreateAccountBankProps) => {
  const { mutateAsync } = useCreateAccountBankMutation();
  const { data: listBanks } = useGetListBanksQuery();
  const { data } = useGetUserProfileQuery();

  const { handleSubmit, getInputProps, resetForm, setValues } = useForm({
    structure: [
      {
        name: 'fullName',
        label: 'Tên tài khoản',
        validate: Yup.string().required('Vui lòng nhập tên tài khoản'),
        defaultValue: data?.fullName,
        isDisabled: true,
      },
      {
        name: 'accountNumber',
        label: 'Tài khoản ngân hàng',
        validate: Yup.string().required('Vui lòng nhập tài khoản ngân hàng'),
      },
      {
        name: 'bankId',
        label: 'Ngân hàng',
        validate: Yup.string().required('Vui lòng chọn Ngân hàng'),
      },
    ],
    onSubmit: async (values) => {
      const normalizedValues = {
        bankId: values.bankId,
        accountNumber: values.accountNumber,
      };
      try {
        await mutateAsync(normalizedValues);
        toast.success('Tạo Ngân hàng mới thành công', { duration: 1500 });
        resetForm();
        forceUpdateTable();
        onClose();
      } catch (error) {
        console.log('error', error);
      }
    },
  });

  return (
    <div className='wrap-pop-up-create-user'>
      <PopupWraper center title='Tạo mới Ngân hàng' onClose={() => onClose()}>
        <div className='container-fluid'>
          <div className='row wrap-form-create-user'>
            <InputWraper
              className='col-lg-12'
              inputProps={getInputProps('bankId')}
              renderInput={(props) => (
                <InputSelect
                  {...props}
                  onChange={(e) => {
                    setValues({ bankId: '' });
                    props.onChange(e);
                  }}
                  options={listBanks?.data?.map((item) => ({
                    label: item.shortName + ' - ' + item.name,
                    value: item.id,
                    logo: item.logo,
                  }))}
                  components={{
                    Menu: CustomMenu,
                    Control: CustomControl,
                    SingleValue: CustomSingleValue,
                    Option: CustomOption,
                  }}
                />
              )}
            />
            <InputWraper
              className='col-lg-12'
              inputProps={getInputProps('fullName')}
              component={InputText}
            />
            <InputWraper
              className='col-lg-12'
              inputProps={getInputProps('accountNumber')}
              component={InputText}
            />
          </div>
          <p className='text-danger'>
            * Vui lòng kiểm tra thật kĩ các thông tin mà Quý khách vừa nhập
            trước khi thực hiện chọn "THÊM NGÂN HÀNG"
          </p>
        </div>

        <div className='wrap-button-create-user'>
          <Button
            label='Thêm ngân hàng'
            type='submit'
            onClick={handleSubmit}
            buttonType='success'
          />
          <Button label='Trở về' buttonType='grey' onClick={() => onClose()} />
        </div>
      </PopupWraper>
    </div>
  );
};

export default CreateUser;
